import { render, staticRenderFns } from "./friendsPanel.vue?vue&type=template&id=5ce171f5&scoped=true&"
import script from "./friendsPanel.vue?vue&type=script&lang=js&"
export * from "./friendsPanel.vue?vue&type=script&lang=js&"
import style0 from "./friendsPanel.vue?vue&type=style&index=0&id=5ce171f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce171f5",
  null
  
)

export default component.exports